export default {
    // 手机验证码
    sendCode: {
        method: "post",
        url: "/verification_code"
    },
    // 手机登录
    login: {
        method: "post",
        url: "/tenants/login"
    },
    // 商户详情
    tenantDetail: {
        method: "get",
        url: "/tenants/:id"
    },
    // 商户编辑
    tenantEdit: {
        method: "patch",
        url: "/tenants/:id"
    },
    // 商户小程序详情
    antMiniProgramsDetail: {
        method: "get",
        url: "/ant_mini_programs/:id"
    }
};


// WEBPACK FOOTER //
// ./src/api/tenants.js